<template>
  <div>
    <div class="row pl-3">
      <div class="col-12 col-md-6 h-100 border rounded preview-items d-flex justify-content-center align-items-center">
        <div v-if="!media" class="src-view"></div>
        <div class="media-container" :id="`media-container-${this.mediaId}`">
          <div :id="`media-container-section-${this.mediaId}`"></div>
        </div>
        <!-- <viewer v-else :item="media" /> -->
      </div>

      <div class="col-12 col-md-6">
        <label>{{ title }}</label>
        <p></p>
        <p><small>* Carregue um aquivo novo ou busque um da sua biblioteca</small></p>

        <a
          data-toggle="modal"
          :data-target="`#${modal}`"
          href="#">Abrir a biblioteca</a>
      </div>
    </div>
    <library @returnMedia="setMedia" :modal="modal" />
  </div>
</template>

<script>
import Library from "./Library"
import Viewer from './Viewer'
import Vue from 'vue'

export default {
  components: {
    "library": Library,
    "viewer": Viewer
  },
  props: {
    title: {
      required: true,
      type: String
    },

    modal: {
      required: true,
      type: String
    },

    itemDefault: {
      default: undefined
    },
  },
  data () {
    return {
      media: undefined,
      mediaId: undefined,
    }
  },
  watch: {
    itemDefault: {
      immediate: true,
      handler(val, old) {
        if ( val == undefined || val == '' ) {
          this.media = undefined
        } else if ( val != old ) {
          this.media = val
          this.makePreview(this.media)
        }
      }
    }
  },
  methods: {
    setMedia: function ( item ) {
      this.media = item
      this.$emit('setItemValue', item)
      this.makePreview(this.media)
      $(`#${this.modal}`).modal('hide')
    },

    makePreview: function (media) {
      const container = document.getElementById(`media-container-${this.mediaId}`)
      container.innerHTML = ""

      const video = document. createElement("div");
      video.id = `media-container-section-${this.mediaId}`;

      container.appendChild(video)

      const VideoObj = Vue.extend(Viewer)
      const videoInstance = new VideoObj({
        propsData: {
          item: media
          // video: this.leassonPlaying.video
        }
      })
      videoInstance.$mount(`#media-container-section-${this.mediaId}`)
    }
  },
  mounted() {
    this.mediaId = Math.floor(Math.random() * 100 - 10) + 10;
  }
}
</script>
